module.exports = __webpack_public_path__ + "static/media/tract.ed3dd59d.png";